export default "__VITE_ASSET__Ct0j_ad7__"